import { useState, type InputHTMLAttributes } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

export interface PasswordInputProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  error?: string;
  helperText?: string;
}

const PasswordInput = ({
  id,
  label,
  error,
  helperText,
  className = '',
  ...rest
}: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => setShowPassword((prev) => !prev);

  const inputClasses =
    `form-control ${error ? 'is-invalid' : ''} ${className}`.trim();

  return (
    <div className="form-floating mb-3 position-relative">
      <input
        id={id}
        type={showPassword ? 'text' : 'password'}
        className={inputClasses}
        placeholder={rest.placeholder || label}
        aria-label={label}
        aria-invalid={!!error}
        aria-describedby={
          error ? `${id}-error` : helperText ? `${id}-help` : undefined
        }
        {...rest}
      />
      <label htmlFor={id}>{label}</label>
      <button
        type="button"
        className="btn btn-link nova-password-toggle"
        onClick={togglePassword}
        aria-label={showPassword ? 'Hide password' : 'Show password'}
        tabIndex={-1}
      >
        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
      </button>
      {helperText && !error && (
        <div id={`${id}-help`} className="form-text nova-helper-text">
          {helperText}
        </div>
      )}
      {error && (
        <div id={`${id}-error`} className="invalid-feedback">
          {error}
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
